function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import SideBySideTextAndAsset from "segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset";
import Title from "segments/desktop/core-components/title/title";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import { StyledSideBySideTitleParagraphComponent } from "./side-by-side-title-paragraph-component.scss";
const SideBySideTitleParagraphComponent = (props)=>{
    const { titleProps, paragraphProps, titleAdvancedProps, paragraphAdvancedProps, paragraphVerticalAlignment } = props, restProps = _object_without_properties(props, [
        "titleProps",
        "paragraphProps",
        "titleAdvancedProps",
        "paragraphAdvancedProps",
        "paragraphVerticalAlignment"
    ]);
    const titlePropsIncludingAdvanced = _object_spread({}, titleProps, titleAdvancedProps);
    const paragraphPropsIncludingAdvanced = _object_spread_props(_object_spread({}, paragraphProps, paragraphAdvancedProps), {
        topic: "",
        title: ""
    });
    return /*#__PURE__*/ _jsx(StyledSideBySideTitleParagraphComponent, {
        paragraphVerticalAlignment: paragraphVerticalAlignment,
        titleMinWidth: titleAdvancedProps === null || titleAdvancedProps === void 0 ? void 0 : titleAdvancedProps.titleMinWidth,
        className: "side-by-side-title-paragraph-component",
        children: /*#__PURE__*/ _jsx(SideBySideTextAndAsset, _object_spread({
            paragraphVerticalAlignment: "top",
            replaceTextComponent: Title,
            replaceTextComponentProps: titlePropsIncludingAdvanced,
            replaceAssetComponent: FullParagraph,
            replaceAssetComponentProps: paragraphPropsIncludingAdvanced
        }, restProps))
    });
};
export default SideBySideTitleParagraphComponent;
SideBySideTitleParagraphComponent.defaultProps = {
    paddingTop: "48px",
    paddingBottom: "48px",
    fullParagraph: {},
    titleProps: Title.defaultProps,
    paragraphProps: {
        body: "Boost your team’s alignment, efficiency, and productivity by customizing any workflow to fit your needs."
    },
    alignToLogo: true
};
